/**
 * Form IDs for GTM events
 * 
 * Each form must have a unique ID for tracking in Google Tag Manager
 * and Google Analytics. Use these enums instead of hardcoding IDs in components.
 * 
 * Format: UUID v4
 */
export enum FormId {
  /** Get Quote Form - Page: /get-quote */
  GET_QUOTE = 'bb1262cd-69fa-4637-a83e-03879c8acf75',
  
  /** Support Contact Form - Page: /support */
  SUPPORT_CONTACT = 'a3f8e2d1-4c9b-4a7e-8f3d-2b5c6e9a1f4d',
  
  /** Payment Form - Page: /order */
  PAYMENT = '7e4b9c2a-5f8d-4e1a-9b3c-6d7e8f9a0b1c',
}

/**
 * Form names for GTM
 */
export enum FormName {
  GET_QUOTE = 'Get Quote Form',
  SUPPORT_CONTACT = 'Support Contact Form',
  PAYMENT = 'Payment Form',
}

/**
 * GTM event types for forms
 */
export enum FormEvent {
  // Submit events
  GET_QUOTE_SUBMIT = 'get_quote_submit',
  SUPPORT_SUBMIT = 'support_form_submit',
  PAYMENT_SUBMIT = 'payment_form_submit',
  
  // Error events
  CONTACT_ERROR = 'contact_form_error',
  PAYMENT_ERROR = 'payment_form_error',
  
  // Success events
  GET_QUOTE_SUCCESS = 'get_quote_success',
  SUPPORT_SUCCESS = 'support_form_success',
  
  // GA4 Enhanced Ecommerce events
  PURCHASE = 'purchase', // GA4 standard purchase event
}
